<style>
    .diia-button-style {
        background-color: #000 !important;
        border-radius: 20px !important;
        color: #fff !important;
        padding: 12px 28px !important;
        font-size: 13px;
        font-weight: normal !important;
        line-height: 1 !important;
    }

    .diia-filter-button-style {
        border: 2px #bbb solid; 
        border-radius: 20px;
        font-size: 13px !important;
        font-weight: normal !important;
        line-height: 1 !important;
    }

    .diia-filter-button-style:hover {
        background-color: #fff !important;
    }

    .theme--light.v-btn:focus::before, .theme--light.v-btn--active::before, .theme--light.v-btn:hover::before, .theme--light.v-btn--active:focus::before {
        background-color: transparent !important;
        opacity: 0 !important;
    }


    .lower-text > .v-input__control > .v-input__slot > .v-select__slot > .v-label {
        font-size: 13px! important;
    }

    v-checkbox > * {
        color: black !important;
    }

    .filter-expansion-panels > .v-expansion-panel::before {
        box-shadow: none !important;
    }

    .filter-expansion-panels > .v-expansion-panel:not(:first-child)::after {
        border-top: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active > .v-expansion-panel-header {
        min-height: inherit !important;
        border-bottom: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active > .v-expansion-panel-content {
        border-bottom: 1px solid black !important;
    }

    .filter-expansion-panels > .side-help-menu-expansion-panel:first-child > .side-help-menu-expansion-panel-header {
        border-top: 1px solid black !important;
    }

    .filter-expansion-panel {
        padding-bottom: 20px;
        border-radius: 0px !important;
        background-color: transparent !important;
    }

    .filter-expansion-panel-header {
        padding: 8px 0px 18px 0px;
        font-size: 18px;
        line-height: 24px;
        border-top: 0px !important;
        border-bottom: 2px solid black;
    }

    .filter-expansion-panel-content > .v-expansion-panel-content__wrap {
        padding: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel {
        margin-top: 0px !important;
    }

    .filter-list-item-title {
        line-height: 24px; 
        font-size: 14px !important;
        font-weight: 300px;
    }

    .v-autocomplete .v-select__selections {
        word-break: break-all !important;
    }

    .list-filter-autocomplete-item {
        padding: 10px;
        width: 100%;
    }
    .list-filter-autocomplete-item:hover {
        background-color: #E7EEF3;
    }
</style>
<!-- .v-text-field > .v-input__control > .v-input__slot:before {
    border-image: linear-gradient(90deg, #2833d0 0, #7179ef 17.19%, #bf98c6 48.44%, #f1acac 100%) !important;
}
-->
<template>
    <v-card elevation="0" class="pa-0 ma-0 pt-2">
            <v-card-text class="pa-0 ma-0" :key="key_render">
                    <v-expansion-panels class="filter-expansion-panels" multiple>
                            <v-expansion-panel class="filter-expansion-panel" v-for="[setting_index, setting] of filters.entries()" :key="setting.name">
                                <v-expansion-panel-header class="filter-expansion-panel-header">
                                    <div class="mt-0">{{ setting.name }}</div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="filter-expansion-panel-content">
                                    <v-list dense class="mt-4" v-if="setting.type == 'multiselect'">
                                        <v-list-item-group
                                            v-model="form_v_model[setting_index]"
                                            color="primary"
                                        >
                                            <v-checkbox class="ma-0" color="black" @change="multiselectCheckboxChanged($event, setting.code, item, filters_values[setting.code])" v-for="item in filters_values[setting.code]" :key="item + filters_values[setting.code][item]" :off-icon="'mdi-checkbox-blank-outline'" :on-icon="'mdi-checkbox-outline'" :ripple="false" :label="item"></v-checkbox>
                                        </v-list-item-group>
                                    </v-list>
                                    <template v-if="setting.type == 'daterange'">
                                        <v-text-field
                                            v-model="form_v_model[setting_index]"
                                            label="Діапазон дат"
                                            prepend-icon="mdi-calendar"
                                            @click:clear="clearDaterange(setting.code, setting_index)"
                                            clearable
                                            style="max-width: 500px;"
                                            readonly
                                        ></v-text-field>
                                        <div>
                                            <v-spacer></v-spacer>
                                            <v-date-picker
                                                color="black"
                                                no-title
                                                @change="daterangeChanged($event, setting.code)"
                                                v-model="form_v_model[setting_index]"
                                                full-width
                                                style="max-width: 500px;"
                                                range
                                            ></v-date-picker>
                                            <v-spacer></v-spacer>
                                        </div>
                                    </template>
                                    <template v-if="setting.type == 'multiselectsearch'">
                                        <v-autocomplete
                                            small-chips
                                            placeholder="Введіть назву організації"
                                            persistent-placeholder
                                            :menu-props="{ 'max-width': '600px' }"
                                            v-model="form_v_model[setting_index]"
                                            multiple
                                            :items="filters_values[setting.code]"
                                            item-text="value"
                                            item-value="key"
                                            @change="multiselectsearchChanged($event, setting.code)"
                                        >
                                        <template v-slot:item="{ item }">
                                            <div class="d-flex flex-column list-filter-autocomplete-item"> 
                                                <span>{{ item.value }}</span>
                                            </div>
                                        </template>
                                        </v-autocomplete>
                                    </template>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                    </v-expansion-panels>
            </v-card-text>

            <v-card-actions class="justify-end pr-0">
                <v-row class="ma-0 pa-0 flex-column flex-sm-row justify-end">
                <v-btn 
                    class="mb-1 mt-1 diia-button-style"
                    color="black"
                    elevation="0"
                    style="letter-spacing: normal; text-transform: none;"
                    @click="clearFilters"
                >   
                    Очистити
                </v-btn>
                <v-btn 
                    class="mb-1 mt-1 ml-0 ml-sm-3 diia-button-style"
                    color="black"
                    elevation="0"
                    style="letter-spacing: normal; text-transform: none;"
                    @click="applyFilters"
                >   
                    Застосувати
                </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
</template>


<script>
/* eslint-disable */
import clib from "../js/common_lib"
import axios from "axios";
export default {
  name: "LisFilterCardNew",
  components: {},
  props: ['object_type'],
  data: () => ({
    display_items: [
        "Усі",
        "Активні",
        "Неактивні",
        "Фальшиві",
        "Нефальшиві",
        "Неактивні",

    ],
    selectedItem: "",
    dialog: false,
    filters: [],
    key_render: 1,
    filters_values: {},
    selected_filters_values: {},
    form_v_model: [],

    initial_query_params: null,
  }),
    created: function () {
        if (this.object_type == "organization") {
            this.filters = this.$config.configuration.organization.filters.items;
            if (this.$route.name == 'organizations-list' || this.$route.name == "organization-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "information_resource") {
            this.filters = this.$config.configuration.information_resource.filters.items;
            if (this.$route.name == 'information-resources-list' || this.$route.name == "information-resource-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "subsystem") {
            this.filters = this.$config.configuration.subsystem.filters.items;
            if (this.$route.name == 'subsystems-list' || this.$route.name == "subsystem-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "interface") {
            this.filters = this.$config.configuration.information_resource_interface.filters.items;
            if (this.$route.name == 'interfaces-list' || this.$route.name == "interface-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "service") {
            this.filters = this.$config.configuration.service.filters.items;
            if (this.$route.name == 'services-list' || this.$route.name == "service-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "interaction") {
            this.filters = this.$config.configuration.interaction.filters.items;
            if (this.$route.name == 'interactions-list' || this.$route.name == "interaction-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }
        else if (this.object_type == "server") {
            this.filters = this.$config.configuration.server.filters.items;
            if (this.$route.name == 'servers-list' || this.$route.name == "server-detail-info") {
                this.initial_query_params = this.$route.query;
            }
        }

        this.fetchAllFilters();
    },
    computed: {
        dateRangeText () {
            return this.dates.join(' ~ ')
        },
    },

    methods: {
        multiselectCheckboxChanged(new_value, filter_code, selected_item, all_items) {
            for (let list_item in all_items) {
                if (all_items[list_item] == selected_item) {
                    if (new_value) {
                        this.selected_filters_values[filter_code].push(list_item);
                    } else {
                        this.selected_filters_values[filter_code] = this.selected_filters_values[filter_code].filter(function(item) {
                            return item !== list_item
                        })
                    }
                }
            }
        },
        multiselectsearchChanged(new_value, filter_code) {
            this.selected_filters_values[filter_code] = new_value;
        },
        daterangeChanged(new_value, filter_code) {
            this.selected_filters_values[filter_code] = new_value;
        },
        clearDaterange(filter_code, filter_index) {
            this.form_v_model[filter_index] = [];
            this.selected_filters_values[filter_code] = [];
        },
        applyFilters() {
            this.$config.filter_params[this.object_type] = {};

            for (let filter_values in this.selected_filters_values) {
                if (this.selected_filters_values[filter_values] && this.selected_filters_values[filter_values].length > 0) {
                    this.$config.filter_params[this.object_type][filter_values] = this.selected_filters_values[filter_values].join(',');
                }
            }

            let selected_filters_verbose = [];

            for (let filter_values in this.selected_filters_values) {
                if (this.selected_filters_values[filter_values] && this.selected_filters_values[filter_values].length > 0) {
                    let current_filter = this.filters.find(function (x) {
                        return x.code == filter_values;
                    });

                    let array_values = [];

                    if (current_filter.type == "multiselect") {
                        for (let j in this.selected_filters_values[filter_values]) {
                            let eng = this.selected_filters_values[filter_values][j];
                            array_values.push(this.filters_values[filter_values][eng]);
                        }

                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': array_values.join(',')
                        });
                    }

                    if (current_filter.type == "daterange") {
                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': this.selected_filters_values[filter_values].join(',')
                        });
                    }

                    if (current_filter.type == "multiselectsearch") {
                        for (let object_item in this.selected_filters_values[filter_values]) {
                            let object_key = this.selected_filters_values[filter_values][object_item];
                            let obj = this.filters_values[filter_values].find(function (x) {
                                return x.key == object_key;
                            });
                            
                            if (obj)
                                array_values.push(obj.value);
                        }

                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': array_values.join(',')
                        });
                    }
                }
            }

            this.$emit('on-filters-apply', this.object_type, selected_filters_verbose);
        },
        clearFilters() {
            this.$emit('on-filters-clear', this.object_type);
        },
        async fetchAllFilters() {
            for (let filter in this.filters) {
                if (this.filters[filter].values_source == 'external') {
                    await this.fetchFilterValues(this.filters[filter].code, this.$config.backend_url + this.filters[filter].endpoint + '&env=' + this.$config.query_params.env);
                }

                if (this.initial_query_params) {
                    let query_value = this.initial_query_params[this.filters[filter].code];
                    if (query_value) {
                        this.selected_filters_values[this.filters[filter].code] = query_value.split(',');
                    } else {
                        this.selected_filters_values[this.filters[filter].code] = [];
                    }
                } else {
                    this.selected_filters_values[this.filters[filter].code] = [];
                }
            }

            if (this.initial_query_params) {
                this.applyFilters();
            }

            this.key_render += 1;
        },
        async fetchFilterValues(code, url) {
            return axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.filters_values[code] = response.data;
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
        }
    }
}
</script>